import React from 'react';
import {APP_VERSION} from '../../constants/version';
import './VersionLabel.css';

function VersionLabel({className}) {
  return <span className={`app-version ${className}`}>
    {`v${APP_VERSION} (beta test)`}
  </span>;
}

export default VersionLabel;
